import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'; 
import 'bootstrap/dist/js/bootstrap.js';
import router from './router';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min.js';
import axios from 'axios';

const app = createApp(App);

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

app.use(router);
app.mount('#app');
